/**
 * PT-BR locale prefix routes (`/pt-br/...`). Declared before `/:username` so `pt-br`
 * is not treated as a username.
 *
 * Paths mirror `info.jsx`, `questions.jsx`, `social.jsx`, and public `profile.jsx` routes.
 */
import React, { lazy } from 'react'
import { Navigate } from 'react-router-dom'
import ViewFeed from '@/pages/feed'
import SearchRedirect from './SearchRedirect'
import DoubledSportsRedirect from './DoubledSportsRedirect'
import ViewMarketPage from '@/pages/market-page'
import { howItWorksUrl, notFoundUrl, brazilElectionsUrl } from '@/urls'

const ViewFeedback = lazy(() => import('@/pages/ViewFeedback'))
const ViewNotFound = lazy(() => import('@/pages/ViewNotFound'))
const ViewAbout = lazy(() => import('@/pages/about'))
const ViewLeaderboard = lazy(() => import('@/pages/leaderboard'))
const ViewBrazilElections = lazy(() => import('@/pages/brazil-elections'))
const ViewUserList = lazy(() => import('@/pages/user-list'))
const ViewPublicProfile = lazy(() =>
  import('@/pages/public-profile').then(module => ({ default: module.ViewPublicProfile }))
)

const PT = '/pt-br'

export default [
  { path: `${PT}/q/suggest`, element: <Navigate to={`${PT}/i/feedback/suggestion`} replace /> },
  { path: [`${PT}/i/feedback`, `${PT}/i/feedback/:type`], element: <ViewFeedback /> },
  { path: `${PT}${howItWorksUrl()}`, element: <ViewAbout /> },
  { path: `${PT}${notFoundUrl()}`, element: <ViewNotFound /> },
  { path: PT, element: <ViewFeed /> },
  { path: `${PT}/`, element: <ViewFeed /> },
  { path: `${PT}/manifest`, element: <ViewFeed /> },
  { path: `${PT}/markets/sports/sports/*`, element: <DoubledSportsRedirect /> },
  { path: `${PT}/markets/*`, element: <ViewFeed /> },
  { path: `${PT}/tags/*`, element: <ViewFeed /> },
  { path: `${PT}/markets/tags`, element: <ViewFeed /> },
  { path: `${PT}/search`, element: <SearchRedirect /> },
  { path: `${PT}${brazilElectionsUrl()}`, element: <ViewBrazilElections /> },

  { path: `${PT}/q/feed`, element: <Navigate to={`${PT}/`} replace /> },
  {
    path: [`${PT}/q/:questionId`, `${PT}/q/:questionId/:questionSlug`],
    element: <ViewMarketPage />,
  },
  { path: `${PT}/q/`, element: <Navigate to={`${PT}/`} replace /> },

  { path: `${PT}/c/leaderboard`, element: <ViewLeaderboard /> },

  { path: `${PT}/:username/followers`, element: <ViewUserList isFollowingList={false} key="pt-br-followers" /> },
  { path: `${PT}/:username/following`, element: <ViewUserList isFollowingList={true} key="pt-br-following" /> },
  { path: `${PT}/:username`, element: <ViewPublicProfile key="pt-br-profile" /> },
]
